import { SearchProps } from '../pages/arc/models/arc-epi-props';
import { Filter, FilterPill, FilterTypes } from './models/search-models';

function parseValue(filter: Filter) {
	if (filter?.type === FilterTypes.from || filter?.type === FilterTypes.to) {
		return filter?.value?.split(':')[1];
	}
	return filter.value;
}

function parseLabel(filter: Filter, dictionary: { [keys: string]: string }) {
	if (filter?.type === FilterTypes.from || filter?.type === FilterTypes.to) {
		return `${filter?.value?.split(':')[0]} ${filter.type}`;
	}
	return dictionary[filter.type];
}

export function generateFilterPills(filters: Filter[], dictionary: { [keys: string]: string }): FilterPill[] {

	return filters?.map(a => { return { type: a?.type, value: parseValue(a), label: parseLabel(a, dictionary), rawValue: a.value, display: a?.display }; });
}

export function getFilterKeyLabelMap(searchSettings: SearchProps) {
	const map = {};
	map[FilterTypes.employee] = searchSettings?.employeeLabel;
	map[FilterTypes.submittedBy] = searchSettings?.submittedByLabel;
	map[FilterTypes.eventType] = searchSettings?.eventTypeLabel;
	map[FilterTypes.lastActivityDate] = searchSettings?.lastActivityDateLabel;
	map[FilterTypes.changeMadeFor] = searchSettings?.changeMadeForLabel;
	map[FilterTypes.changeType] = searchSettings?.changeTypeLabel;
	map[FilterTypes.status] = searchSettings?.statusRowLabel;
	map[FilterTypes.requestBy] = searchSettings?.requestByLabel;
	map[FilterTypes.dateType] = searchSettings?.employeeChangeLogDateTypeLabel;
	return map;
}